// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../resources/product-header-shaped-bg2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#SmartCommandOne {
  display: flex;
  width: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 0 100%, rgba(157, 170, 241, 0.1490196078);
  background-position: 50% 50%;
  flex-direction: row;
}

.SmartCommandOne-left {
  display: flex;
  width: 50%;
  flex-direction: column;
  justify-content: center;
  padding: 120px 0px 120px 300px;
  background: #fff;
}
.SmartCommandOne-left .SmartCommandOne-left-company-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 35px;
  line-height: 148.69%;
  font-variant: small-caps;
  color: #ec6927;
  margin: 60px 0 0 0;
  padding: 0;
}
.SmartCommandOne-left .SmartCommandOne-left-heading {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 43px;
  line-height: 1.4;
  /* or 50px */
  color: #1c2640;
  margin-bottom: 30px;
}
.SmartCommandOne-left .SmartCommandOne-left-divider {
  width: 150px;
  height: 0px;
  border-top: 1.5px solid #1c2640;
  margin-bottom: 30px;
}
.SmartCommandOne-left .SmartCommandOne-left-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 30px;
  color: #52667c;
  margin: 0;
  padding: 0 103px 0 0;
}
.SmartCommandOne-left #SmartCommandOne-schedule-a-demo {
  width: 133px;
  height: 36px;
  background: #ec6927;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  border: none;
  color: white;
  cursor: pointer;
  margin-top: 30px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: #ffffff;
}

.SmartCommandOne-right {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}
.SmartCommandOne-right img.SmartCommandOne-right-bg-image {
  width: 550px;
  height: auto;
  position: absolute;
  left: 70px;
  box-shadow: 5px 5px 5px 0px rgba(51, 51, 51, 0.2509803922);
  border-radius: 12px;
}
.SmartCommandOne-right .SmartCommandOne-right-slider-section {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  width: 420px;
  min-height: 120px;
  background: #ffffff;
  box-shadow: 0px 4px 10px rgba(106, 106, 106, 0.4);
  border-radius: 7px;
  border-top: 15px solid #ec6927;
  position: absolute;
  left: 15px;
  margin-top: 280px;
  padding: 15px 15px 30px;
  transition: all 0.3s ease 0s;
  cursor: pointer;
}
.SmartCommandOne-right .SmartCommandOne-right-slider-section:hover {
  transform: scale(1.05);
}
.SmartCommandOne-right .SmartCommandOne-right-slider-section .animated-slider {
  display: flex;
}
.SmartCommandOne-right .SmartCommandOne-right-slider-section .SmartCommandOne-right-slider-section-check-icon {
  width: 20px;
  height: 20px;
  margin: 7px 15px 0;
}
.SmartCommandOne-right .SmartCommandOne-right-slider-section p {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 35px;
  color: #ec6927;
  margin: 0;
  padding: 0;
}
.SmartCommandOne-right .SmartCommandOne-right-slider-section .SmartCommandOne-right-slider-dots-section {
  display: flex;
  flex-direction: row;
  position: absolute;
  bottom: 12px;
  right: 10px;
}
.SmartCommandOne-right .SmartCommandOne-right-slider-section .SmartCommandOne-right-slider-dots-section .SmartCommandOne-right-slider-dot {
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #c4c4c4;
  margin-right: 7px;
  cursor: pointer;
}
.SmartCommandOne-right .SmartCommandOne-right-slider-section .SmartCommandOne-right-slider-dots-section .SmartCommandOne-right-slider-dot.active {
  background-color: #1c2640 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/SmartCommand/SectionOne/sectionOne.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,WAAA;EAEA,uGAAA;EAGG,4BAAA;EACH,mBAAA;AAFD;;AAKA;EACC,aAAA;EACA,UAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,gBAAA;AAFD;AAIC;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AAFF;AAKC;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EAEA,cAAA;EACA,mBAAA;AAJF;AAQC;EACC,YAAA;EACA,WAAA;EACA,+BAAA;EACA,mBAAA;AANF;AASC;EACC,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,oBAAA;AAPF;AAUC;EACC,YAAA;EACA,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AARF;;AAYA;EACC,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AATD;AAWC;EACC,YAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,0DAAA;EACA,mBAAA;AATF;AAaC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,iDAAA;EACA,kBAAA;EACA,8BAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,uBAAA;EACA,4BAAA;EACA,eAAA;AAXF;AAaE;EAEC,sBAAA;AAXH;AAcE;EACC,aAAA;AAZH;AAeE;EACC,WAAA;EACA,YAAA;EACA,kBAAA;AAbH;AAgBE;EACC,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;AAdH;AAiBE;EACC,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAfH;AAiBG;EACC,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAfJ;AAiBI;EACC,oCAAA;AAfL","sourcesContent":["#SmartCommandOne {\n\tdisplay: flex;\n\twidth: 100%;\n\t// height: 97vh;\n\tbackground: url('../../../resources/product-header-shaped-bg2.png') no-repeat\n\t\t\t0 100%,\n\t\t#9daaf126;\n    background-position: 50% 50%;\n\tflex-direction: row;\n}\n\n.SmartCommandOne-left {\n\tdisplay: flex;\n\twidth: 50%;\n\tflex-direction: column;\n\tjustify-content: center;\n\tpadding: 120px 0px 120px 300px;\n\tbackground: #fff;\n\n\t.SmartCommandOne-left-company-text {\n\t\tfont-family: Roboto;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tfont-size: 35px;\n\t\tline-height: 148.69%;\n\t\tfont-variant: small-caps;\n\t\tcolor: #ec6927;\n\t\tmargin: 60px 0 0 0;\n\t\tpadding: 0;\n\t}\n\n\t.SmartCommandOne-left-heading {\n\t\tfont-family: Roboto;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tfont-size: 43px;\n\t\tline-height: 1.4;\n\t\t/* or 50px */\n\n\t\tcolor: #1c2640;\n\t\tmargin-bottom: 30px;\n\t\t// margin-top: 0;\n\t}\n\n\t.SmartCommandOne-left-divider {\n\t\twidth: 150px;\n\t\theight: 0px;\n\t\tborder-top: 1.5px solid #1c2640;\n\t\tmargin-bottom: 30px;\n\t}\n\n\t.SmartCommandOne-left-text {\n\t\tfont-family: Roboto;\n\t\tfont-style: normal;\n\t\tfont-weight: normal;\n\t\tfont-size: 18px;\n\t\tline-height: 30px;\n\t\tcolor: #52667c;\n\t\tmargin: 0;\n\t\tpadding: 0 103px 0 0;\n\t}\n\n\t#SmartCommandOne-schedule-a-demo {\n\t\twidth: 133px;\n\t\theight: 36px;\n\t\tbackground: #ec6927;\n\t\tbox-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);\n\t\tborder-radius: 3px;\n\t\tborder: none;\n\t\tcolor: white;\n\t\tcursor: pointer;\n\t\tmargin-top: 30px;\n\t\tfont-family: Roboto;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tfont-size: 15px;\n\t\tline-height: 20px;\n\t\tcolor: #ffffff;\n\t}\n}\n\n.SmartCommandOne-right {\n\twidth: 50%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: relative;\n\n\timg.SmartCommandOne-right-bg-image {\n\t\twidth: 550px;\n\t\theight: auto;\n\t\tposition: absolute;\n\t\tleft: 70px;\n\t\tbox-shadow: 5px 5px 5px 0px #33333340;\n\t\tborder-radius: 12px\n\n\t}\n\n\t.SmartCommandOne-right-slider-section {\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\talign-items: flex-start;\n\t\tjustify-content: flex-start;\n\t\twidth: 420px;\n\t\tmin-height: 120px;\n\t\tbackground: #ffffff;\n\t\tbox-shadow: 0px 4px 10px rgba(106, 106, 106, 0.4);\n\t\tborder-radius: 7px;\n\t\tborder-top: 15px solid #ec6927;\n\t\tposition: absolute;\n\t\tleft: 15px;\n\t\tmargin-top: 280px;\n\t\tpadding: 15px 15px 30px;\n\t\ttransition: all 0.3s ease 0s;\n\t\tcursor: pointer;\n\n\t\t&:hover{\n\t    \t-webkit-transform: scale(1.05);\n\t\t\ttransform: scale(1.05);\n\t    }\n\n\t\t.animated-slider{\n\t\t\tdisplay: flex;\n\t\t}\n\n\t\t.SmartCommandOne-right-slider-section-check-icon {\n\t\t\twidth: 20px;\n\t\t\theight: 20px;\n\t\t\tmargin: 7px 15px 0;\n\t\t}\n\n\t\tp {\n\t\t\tfont-family: Roboto;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: normal;\n\t\t\tfont-size: 24px;\n\t\t\tline-height: 35px;\n\t\t\tcolor: #ec6927;\n\t\t\tmargin: 0;\n\t\t\tpadding: 0;\n\t\t}\n\n\t\t.SmartCommandOne-right-slider-dots-section {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\tposition: absolute;\n\t\t\tbottom: 12px;\n\t\t\tright: 10px;\n\n\t\t\t.SmartCommandOne-right-slider-dot {\n\t\t\t\twidth: 8px;\n\t\t\t\theight: 8px;\n\t\t\t\tborder-radius: 4px;\n\t\t\t\tbackground: #c4c4c4;\n\t\t\t\tmargin-right: 7px;\n\t\t\t\tcursor: pointer;\n\n\t\t\t\t&.active {\n\t\t\t\t\tbackground-color: #1c2640 !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
